import React from 'react';
import { styled } from 'styled-components';
import SvgAudioDescription from '../../../../play-core/icons/AudioDescription';
import SvgMultiLanguage from '../../../../play-core/icons/MultiLanguage';
import { Colors, hexToRGB } from '../../../../play-core/styles/Colors';
import { Fonts } from '../../../../play-core/styles/Fonts';
import { IconWrapper } from '../IconWrapper/IconWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
export const InfoIcon = ({
  icon,
  text
}) => /*#__PURE__*/_jsx(Layout, {
  children: icon ? /*#__PURE__*/_jsx(IconWrapper, {
    icon: icon,
    size: 20
  }) : text
});
const Layout = styled.div.withConfig({
  displayName: "InfoIcon__Layout",
  componentId: "sc-z9dlor-0"
})(["display:flex;align-items:center;justify-content:center;text-align:center;color:", ";background-color:", ";", ";border-radius:4px;width:24px;height:24px;"], Colors.GREY_3a3a3a, hexToRGB(Colors.WHITE, 0.6), Fonts.medium(14));
export const getInfoIcons = (videoDetail, t) => {
  const {
    subtitlesAvailable,
    multiAudioAvailable,
    audioDescriptionAvailable
  } = videoDetail;
  const infoIcons = [];
  if (subtitlesAvailable) {
    infoIcons.push({
      text: t('global.subtitleShorthand')
    });
  }
  if (multiAudioAvailable) {
    infoIcons.push({
      icon: /*#__PURE__*/_jsx(SvgMultiLanguage, {})
    });
  }
  if (audioDescriptionAvailable) {
    infoIcons.push({
      icon: /*#__PURE__*/_jsx(SvgAudioDescription, {})
    });
  }
  return infoIcons;
};